import * as Immutable from 'immutable';
import isNil from 'lodash/isNil';
import merge from 'lodash/merge';
import {createReducer} from 'redux-store';
import * as SessionsConstants from '../constants/sessions-constants';

import type {List, MapOf} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type SessionsStore = {
    cachedSessions: List<unknown>;
    courses: List<unknown>;
    matchingSessionsCount: number;
    locations: List<unknown>;
    organizations: List<unknown>;
    scenarios: List<unknown>;
    sessions: List<unknown>;
    simulators: List<unknown>;
    users: MapOf<{
        owner: List<unknown>;
        participants: List<unknown>;
    }>;
};

const initialState = (): Pick<SessionsStore, 'cachedSessions'> => {
    return {
        cachedSessions: Immutable.List(),
    };
};

const baseState = (): Omit<SessionsStore, 'cachedSessions'> => {
    return {
        courses: Immutable.List(),
        matchingSessionsCount: 0,
        locations: Immutable.List(),
        organizations: Immutable.List(),
        scenarios: Immutable.List(),
        sessions: Immutable.List(),
        simulators: Immutable.List(),
        users: Immutable.Map({
            owner: Immutable.List(),
            participants: Immutable.List(),
        }),
    };
};

const mapSession = (session) => {
    let title = session.get('title');
    if (!title) {
        const scenario = session.get('scenario');
        if (scenario) {
            title = scenario.get('publicTitle');
            if (!title) {
                title = scenario.get('privateTitle');
            }
        }

        session = session.set('title', title);
    }

    return session;
};

const actionsMap: ActionsMap<SessionsStore> = {
    [SessionsConstants.SESSIONS_SUCCESS]: (state, action) => {
        let sessions = action.data.get('rows').map(mapSession);
        const count = action.data.get('count');

        if (action.query.page !== 0) {
            sessions = state.sessions.concat(sessions);
        }

        return {
            sessions,
            matchingSessionsCount: count,
        };
    },
    [SessionsConstants.COURSES_SUCCESS]: (state, action) => {
        return {
            courses: action.data,
        };
    },
    [SessionsConstants.COURSE_SCENARIOS_SUCCESS]: (state, action) => {
        const courseScenarios = action.data
            .filter((courseItem) => !isNil(courseItem.get('scenario')))
            .map((courseItem) => courseItem.get('scenario'));
        return {
            scenarios: courseScenarios,
        };
    },
    [SessionsConstants.LOCATIONS_SUCCESS]: (state, action) => {
        return {
            locations: action.data,
        };
    },
    [SessionsConstants.ORGANIZATIONS_SUCCESS]: (state, action) => {
        return {
            organizations: action.data.sortBy((org) => org.get('sort')),
        };
    },
    [SessionsConstants.SCENARIOS_SUCCESS]: (state, action) => {
        return {
            scenarios: action.data,
        };
    },
    [SessionsConstants.SIMULATORS_SUCCESS]: (state, action) => {
        return {
            simulators: action.data,
        };
    },
    [SessionsConstants.USERS_SUCCESS]: (state, action) => {
        let users = state.users;
        users = users.set(action.key, action.data);
        return {
            users,
        };
    },
    [SessionsConstants.DISPOSE_SESSIONS_STORE]: () => {
        return baseState();
    },
};

export default createReducer<SessionsStore>(merge(initialState(), baseState()), actionsMap);
